import { SALE_ORDER, SALE_ORDERS, AVAILABLE_ITEMS } from "../../types";

const SaleOrders = (state = {}, action) => {
    if ([AVAILABLE_ITEMS, SALE_ORDERS, SALE_ORDER,].includes(action.type)) {
        state = { ...state, [action.type]: action.payload }
    }
    return state;
}

export default SaleOrders;